"use client";

interface SectionTitleProps {
  children: React.ReactNode;
  className?: string;
}

export function SectionTitle({ children, className }: SectionTitleProps) {
  return (
    <div className={`uppercase text-[10px] font-normal tracking-wider ${className}`}>
      {children}
    </div>
  );
}
